import { create } from 'zustand'

/**
 * Тосты (docs/10 §5): 3–5 с, `aria-live="polite"`, фокус не крадут,
 * у удаления — кнопка «Отменить» с окном 5 с (`undo-support`).
 */

export type ToastTone = 'info' | 'success' | 'warning' | 'danger'

export interface Toast {
  id: string
  message: string
  tone: ToastTone
  /** Мс до автозакрытия; 0 — не закрывать автоматически. */
  timeoutMs: number
  undo?: { label: string; run: () => void }
}

interface ToastState {
  toasts: Toast[]
  push: (toast: Omit<Toast, 'id'> & { id?: string }) => string
  dismiss: (id: string) => void
  clear: () => void
}

export const DEFAULT_TOAST_MS = 4000
export const UNDO_TOAST_MS = 5000

export const useToastStore = create<ToastState>(set => ({
  toasts: [],
  push: toast => {
    const id = toast.id ?? `toast-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`
    set(state => ({ toasts: [...state.toasts, { ...toast, id }] }))
    return id
  },
  dismiss: id => set(state => ({ toasts: state.toasts.filter(toast => toast.id !== id) })),
  clear: () => set({ toasts: [] })
}))

/** Короткий помощник, чтобы компоненты не собирали объект руками. */
export function toast(message: string, tone: ToastTone = 'info'): string {
  return useToastStore.getState().push({ message, tone, timeoutMs: DEFAULT_TOAST_MS })
}
